<template>
  <smd-one-col-layout class="modal-educare-terms-and-conditions">
    <smd-header slot="header" nav>
      <span class="ns-icon-ico028"
            slot="left-actions"
            @click="closeModal"/>

      <text-string label-id="txt131"/>

      <span class="ns-icon-ico001"
            slot="right-actions">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </smd-header>

    <div class="smd-checkbox__row">
      <text-string label-id="txt1431"/>
    </div>

    <div class="smd-checkbox__row justify-content-center">
      <smd-checkbox v-model="educareTerms">
        <p class="Label2">I agree to the terms & conditions above</p>
      </smd-checkbox>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import CloseModalMixin from '@/mixins/close-modal-mixin';
  import {mapFields} from 'vuex-map-fields';

  export default {
    name: 'modal-educare-terms-and-conditions',
    mixins: [CloseModalMixin],
    computed: {
      ...mapFields({
        educareTerms: 'opt_in.educare',
      }),
    },
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .modal-educare-terms-and-conditions {
    .smd-checkbox__row {
      margin-bottom: space(m);

      .smd-checkbox {
        align-items: flex-start;
      }
    }
  }
</style>
